<template>
    <div>
        <h2 style="margin-top: 100px">CROSS-PLATFORM</h2>
        <div class="login-form mt-5">
            <b-card style="max-width: 40rem;" class="mb-2 mx-auto">
                <p id="error" class="text-center maintenance-message text-danger mt-3">
                    The tool is currently down for maintenance.
                </p>
                <div class="modal-footer clearfix">
                    <div class="float-right">
                        <b-button ref="inputButtonMaintenance" variant="primary" size="lg" @click="backToLogin">
                            To Portal
                        </b-button>
                    </div>
                </div>
            </b-card>
        </div>

        <div v-if="visibleBanner" class="alert alert-dark text-center mb-0 banner browserWarning" role="alert">
            NOTE: The tool is optimized for Chrome browser
            <button type="button" class="btn btn-primary btn-sm ms-3 mb-lg-0 browserBannerBtn" @click="hideBrowserBanner()">
                OK
            </button>
        </div>
        <p>Contact support@mms.se for questions about login/tool</p>
    </div>
</template>

<script>
import globalConfig from "@/mixins/globalConfig"
import router from "@/router/index"

export default {
    name: "Maintenance",
    mixins: [globalConfig],
    data() {
        return {
            visibleBanner: false,
        }
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        this.$nextTick(() => {
            this.visibleBanner = true
        })
    },
    methods: {
        backToLogin() {
            router.push("/")
        },
        hideBrowserBanner() {
            this.visibleBanner = false
        },
    },
}
</script>

<style scoped>
.maintenance-message {
    font-size: 1.2rem;
    font-weight: bold;
}
.banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}
</style>
